<footer>
  <p>
    Should you need help, please reach out to our
    <a class="support-link" href="mailto:bindingcorporaterules@astrazeneca.com">support team.</a>
  </p>
</footer>
